
import React, { ReactNode, FC } from 'react';
import Meta from '../meta/Meta'
import Header from './Header/Header'
import Footer from './Footer/Footer'

import styles from './Layout.module.scss'
import StickyHeader from './stickyHeader/StickyHeader';
import { IMeta } from '@/src/assets/interfaces/metaInterface';


type Layout = {
    children: ReactNode
    meta: IMeta | null
    className?: string
}

const Layout: FC<Layout> = ({children, className, meta}) => {
  
  return (
    <Meta meta={meta}>
      <div className="scroll-fix"></div>
      <div className={`${styles.layout}`}>
        <StickyHeader>
          <Header/>
        </StickyHeader>
        <main className={`main ${className}`}>{children}</main>
        <Footer/>
      </div>
    </Meta>
  )
}

export default Layout